import React from 'react';

import { UiKit } from 'components';
import { useShippingConfig } from '../context';
import { PAYER } from '../stubs';

export default function Payer({ isDisabled = false }) {
  const { data, errors, isProcessing, onChange } = useShippingConfig();

  const disabled = isProcessing || isDisabled;

  return (
    <UiKit.Radio.Group
      name="shipping-payer"
      value={data.paidBy}
      onChange={value => onChange({ paidBy: value })}
      error={errors.paidBy}
      disabled={disabled}
      gap={12}
    >
      <UiKit.Radio.Card
        value={PAYER.MERCHANT}
        label="We will pay the cost of shipping"
      />
      <UiKit.Radio.Card
        value={PAYER.SHOPPER}
        label="Customer pays (deducted from refund)"
      />
    </UiKit.Radio.Group>
  );
}
